<template>
  <div>
    <el-alert
      class="page_section_card"
      :title="`最后更新时间：${last_time}`"
      type="warning"
      :closable="false"
      show-icon
    >
    </el-alert>
    <el-card header="商品分析" class="page_section_card">
      <keep-alive>
        <dataFilterCompVue
          ref="searchComp"
          :isType="false"
          @search="search"
        ></dataFilterCompVue>
      </keep-alive>
    </el-card>
    <el-card v-loading="loading">
      <el-table :data="tableList" border stripe>
        <el-table-column
          v-for="item in goodsCols"
          :key="item.label"
          :label="item.label"
          :prop="Array.isArray(item.prop) ? '' : item.prop"
          :align="item.align"
          :min-width="item.width"
          :fixed="item.fixed"
          :sortable="item.sortable"
        >
          <template slot-scope="scope">
            <div v-if="Array.isArray(item.prop)">
              <p>{{ scope.row[item.prop[0]] }}</p>
              <p>至</p>
              <p>{{ scope.row[item.prop[1]] }}</p>
            </div>
            <span v-else>
              <span v-if="item.noFormat">{{ scope.row[item.prop] }}</span>
              <span v-else>{{
                common.formatNumber(scope.row[item.prop], item.toThunsands || 2)
              }}</span>
            </span>
          </template>
        </el-table-column>
      </el-table>
      <pagination-vue
        @sizeChange="sizeInit"
        @currentChange="getList"
        :pageSize="postdata.page_num"
        :total="total"
        :firstPage="firstPage"
      />
    </el-card>
  </div>
</template>
<script>
import goodsCols from "@/assets/mcnTableCols/goodsCols.js";
import paginationVue from "@/components/paginationVue.vue";
import dataFilterCompVue from "../components/dataFilterComp.vue";
export default {
  components: {
    dataFilterCompVue,
    paginationVue,
  },
  data() {
    return {
      goodsCols: goodsCols.columns,
      loading: false,
      last_time: "",
      postdata: {
        page: 1,
        page_num: 20,
      },
      tableList: [],
      total: 0,
      firstPage: 1,
    };
  },
  mounted() {
    this.$refs.searchComp.search();
  },
  methods: {
    search(data) {
      this.postdata = Object.assign(this.postdata, data);
      this.postdata.page = 1;
      this.getList(1);
    },
    getList(page) {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.postdata.page = page || this.firstPage;
      this.axios(
        "get",
        `${this.$pythonHost}tiktokshop/product/analysis_list`,
        this.postdata
      )
        .then((res) => {
          this.loading = false;
          if (res.code == 1) {
            this.tableList = res.data.list;
            this.total = res.data.total_count;
            this.firstPage = res.data.page;
            this.last_time = res.data.last_time;
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    sizeInit(size) {
      this.postdata.page_num = size || 20;
      this.getList(1);
    },
  },
};
</script>
